export default "__VITE_ASSET__v9$HlU8a__"